const state = {
  openedMenu: false,
  overlay: false,
  newProjectModal: false,
  mobile: false,
  showTicketDetails: false,
  showOrderDetails: false
};

const getters = {
  getMenuStatusGetter: state => state.openedMenu,
  getOverlayGetter: state => state.overlay,
  isMobileGetter: state => state.mobile,
  showTicketDetailsGetter: state => state.stateshowTicketDetails,
  showOrderDetailsGetters: state => state.showOrderDetails
};

const mutations = {
  SET_MENU_STATUS(state, data) {
    state.openedMenu = data;
  },
  SET_OVERLAY_STATUS(state, data) {
    state.overlay = data;
  },
  SET_MOBILE_STATUS(state, data) {
    state.mobile = data;
  },
  SET_SHOW_TIKET_STATUS(state, data) {
    state.stateshowTicketDetails = data;
  },
  SET_SHOW_ORDER_STATUS(state, data) {
    state.showOrderDetails = data;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js